/* Lawazen Studio editor: production files.
 * Each used placement is drawn at Printful's exact print-file pixels
 * (spec.placements[].filePx), on a transparent background, as PNG. The
 * Worker refuses any other size, so this is the size check too.
 */
(function () {
  'use strict';
  var S = window.LZPW; if (!S) return;
  var el = S.el, t = S.t;

  S.renderPrint = function (name) {
    var p = S.placement(name);
    return S.fontsReady().then(function () {
      var c = document.createElement('canvas');
      c.width = p.filePx.w; c.height = p.filePx.h;
      S.drawPlacement(c.getContext('2d'), name, 1);
      return new Promise(function (ok, bad) { c.toBlob(function (b) { b ? ok(b) : bad(new Error('png')); }, 'image/png'); });
    });
  };

  /* "Check print file": the exact file, on a checkerboard so transparency shows. */
  S.showPrintFile = function () {
    var used = S.usedPlacements();
    if (!used.length) { S.say(t('empty_design'), 'error'); return; }
    Promise.all(used.map(function (n) { return S.renderPrint(n).then(function (b) { return { n: n, b: b }; }); })).then(function (files) {
      var urls = [];
      var body = el('div', { class: 'lzpw-files' }, files.map(function (f) {
        var u = URL.createObjectURL(f.b); urls.push(u);
        var p = S.placement(f.n);
        return el('figure', { class: 'lzpw-filefig' }, [
          el('img', { src: u, alt: S.placementName(p) }),
          el('figcaption', { text: S.placementName(p) + ' · ' + p.filePx.w + ' × ' + p.filePx.h + ' px' })
        ]);
      }));
      var dlg = el('dialog', { class: 'lzpw-dialog' }, [
        el('h2', { text: t('file_title') }),
        el('p', { class: 'lzpw-small', text: t('file_note') }),
        body,
        el('button', { type: 'button', class: 'lzpw-btn', text: t('close'), onclick: function () { dlg.close(); } })
      ]);
      dlg.addEventListener('close', function () { urls.forEach(URL.revokeObjectURL); dlg.remove(); });
      S.root.appendChild(dlg);
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    }).catch(function () { S.say(t('save_failed'), 'error'); });
  };
})();
